import { LocalStorageService } from 'angular-2-local-storage';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { BbTableService, BbTableSelectOption, TableRow } from '../../../services/bb-table.service';
import { SapiService } from '../../../services/sapi.service';
import { OverlayService } from '../../../services/overlay.service';
import { LocationService } from '../../../services/location.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { AbstractListComponent } from '../../shared/abstract-list.component';

@Component({
	selector: 'repost-list',
	templateUrl: './report-list.component.html',
	styleUrls: ['./report-list.component.scss'],
	providers: [BbTableService, LocationService]
})

export class ReportListComponent extends AbstractListComponent implements OnInit {
	putRight = false;

	constructor(protected bbTableService: BbTableService,
		protected sapiService: SapiService,
		protected router: Router,
		protected localStorageService: LocalStorageService,
		protected overlayService: OverlayService,
		protected translate: TranslateService,
		protected authenticationService: AuthenticationService) {

		super(bbTableService);

		this.listConfiguration = {
			name: 'report',
			basePath: '/analytics/reports'
		};

		this.filterConfig = {
			search: true
		};

		this.authenticationService.hasPermission('put').subscribe(hasRight => this.putRight = hasRight);

	}

	ngOnInit() {

		this.bbTableService
			.setSelect(BbTableSelectOption.none)
			.setLimit(15)
			.sort('createddate', 'desc')
			.linkToUrl();

		super.ngOnInit();
	}

	// override super doubleclick redirect:
	redirectToDetails(row: TableRow) {
		if (row && row.data && row.data.id) {
			this.router.navigate(['analytics/reports', row.data.id, 'contents']);
		}
	}

	duplicate(reportId: number) {
		if (reportId) {
			this.router.navigate(['analytics/reports', 'new', 'contents'], { queryParams: { fromId: reportId } });
		}
	}

	// for easteregg
	loadReportDetail(id: number) {
		const url = this.locationService.server + '/sapi/report/' + id + '/?sesstoken=' + this.sapiService.getSessionToken();
		const anchor = document.createElement('A');
		anchor.setAttribute('href', url);
		anchor.setAttribute('target', '_blank');

		const evt = document.createEvent('MouseEvents');
		evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		anchor.dispatchEvent(evt);
	}
}
